import React from 'react';
import './blogListSection.scss';
import BlogItemComponent from "../../../main/sections/blogSection/components/BlogItemComponent";

export const blogData = [
	{
		id: 0,
		image: require(`../../../brandAssets/sections/bannersSection/banners/RD.webp`),
		text: "Retrodrops: What are they and how can a beginner profit from them?",
		date: "2025-05-15T03:00:00.000Z",
		href: 'retrodrops'
	},
	{
		id: 1,
		image: require(`../../../brandAssets/sections/bannersSection/banners/PV.webp`),
		text: "Comprehensive guide to proxies: Their purpose, functionality, and applications",
		date: "2025-05-16T03:00:00.000Z",
		href: 'proxies'
	},
	// {
	// 	id: 2,
	// 	image: require(`../../../brandAssets/sections/bannersSection/banners/XRP.webp`),
	// 	text: "Ava Protocol on EigenLayer: A Technical Review for Web3",
	// 	date: "2024-09-08T03:00:00.000Z"
	// },

];

interface BlogListSectionProps {
	searchValue: string;
}

const BlogListSection = (props: BlogListSectionProps) => {

	const filteredBlogData = blogData.filter((item) =>
		item.text.toLowerCase().includes(props.searchValue.toLowerCase())
	);

	return (
		<div className="blogListSection">
			<div className="blogListSection__content">
				{
					filteredBlogData.length > 0 ?
						filteredBlogData.map((item: any, index: number) => (
							<BlogItemComponent
								key={`${item.date}-${index}-${item.id}`}
								image={<img src={item.image} alt={item.text} style={{ objectPosition: `${item.href === 'proxies' && "-10px"}` }} />}
								text={item.text}
								date={item.date}
								id={item.id}
								setIndex={() => { }}
								href={item.href}
							/>
						)) : (
							<div className="blogListSection__content_empty">
								<span>No matching blogs found</span>
							</div>
						)
				}
			</div>
		</div>
	);
};

export default BlogListSection;